// 4px solid stripe == platform Card's colorStripe border width.
export const STRIPE_WIDTH = 1;
